<template>
  <el-dialog :visible.sync="dialogVisible"  custom-class="dialogHeight dialogPaddingTop0 appconfig_add" :title="$t('appconfig_add')" >
    <el-row>
      <el-col :span="18">
      <el-form :inline="true" :model="searchdata" class="demo-form-inline" size="small" @submit.native.prevent>
          <el-form-item >
              <el-input v-model="searchdata.data.name" :placeholder="$t('software_name')" @keyup.enter.native="searchTableData"></el-input>
          </el-form-item>
          <el-form-item size="mini">
              <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
              <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
          </el-form-item>
          
      </el-form>
      </el-col>
    </el-row>
    <div>
      <el-table 
      :data="customApps.datas" 
      @selection-change="onSelectionChange" 
      style="width: 100%" 
      header-cell-class-name="tableHeaderbg"
      size="small">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" :label="$t('software_name')" width="180"></el-table-column>
        <el-table-column prop="description" :label="$t('description')" width="180"></el-table-column>
        <el-table-column :label="$t('fettle')">
          <template slot-scope="scope">{{scope.row.activated? $t('active') : $t('inactive')}}</template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-row>
        <el-col :span="24" style="text-align:right">
          <el-button @click="onCancel" size="small" type="primary" plain>{{$t('cancel')}}</el-button>
          <el-button type="primary" @click="onOk" size="small">{{$t('confirm')}}</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>

</template>

<script>
export default {
  props: ["visible"],
  created() {
    this.getData()
  },
  data() {
    return {
      searchdata: {
        domainid: this.$route.query.domainid,
        data:{
          name: "",
        }
      },  
      customApps: {},
      multipleSelection: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    resetSearchTableData(){
      this.searchdata.data.name='';
      this.getData();
    },
    searchTableData(){
      this.getData();
    },
    onOk() {
      // bindApps
      let ids = [];
      this.multipleSelection.forEach(row => {
        ids.push(row.id);
      });
      this.$api.bindCustomApps(
        { domainid: this.$route.query.domainid, data: ids },
        {
          onSucess: resp => {
            if (resp.data.errcode == 0) {
              this.$message({
                showClose: true,
                message: this.$t('msg_add_success'),
                type: "success"
              });
              this.$emit("refresh");
              this.$emit("update:visible", false);
            } else {
              this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "error"
              });
            }
          }
        }
      );
    },
    onCancel() {
      this.$emit("update:visible", false);
    },
    getData(){
      this.$api.getUnbindApps(
        this.searchdata,
        {
          onSucess: resp => {
            this.customApps = resp.data.data;
          }
        }
      );
    },
    onSelectionChange(rows) {
      this.multipleSelection = rows;
    }
  }
};
</script>

<style>
</style>